import { commonLocale } from "./common";
const locale = {
  ...commonLocale,
  locale: 'ur_PK',
  today: 'آج',
  now: 'ابھی',
  backToToday: 'آج واپس',
  ok: 'ٹھیک ہے',
  clear: 'صاف',
  week: 'ہفتہ',
  month: 'مہینہ',
  year: 'سال',
  timeSelect: 'وقت منتخب کریں',
  dateSelect: 'تاریخ منتخب کریں',
  weekSelect: 'ایک ہفتہ کا انتخاب کریں',
  monthSelect: 'ایک مہینہ کا انتخاب کریں',
  yearSelect: 'ایک سال کا انتخاب کریں',
  decadeSelect: 'ایک دہائی کا انتخاب کریں',
  previousMonth: 'پچھلے مہینے (PageUp)',
  nextMonth: 'اگلے مہینے (PageDown)',
  previousYear: 'گزشتہ سال (Control + left)',
  nextYear: 'اگلے سال (Control + right)',
  previousDecade: 'پچھلی دہائی',
  nextDecade: 'اگلی دہائی',
  previousCentury: 'پچھلی صدی',
  nextCentury: 'اگلی صدی'
};
export default locale;